import React from "react"
//import CaminhoRato from "../../Componentes/Cabecalho/CaminhoRato";
import { useActionData, useParams, useLocation } from 'react-router-dom';
import useQuery from "../../Componentes/Util/useQuery.js";

const InicioProdutos = () => {
    //parametros específicos
    let { buscar } = useParams();

    //parametros da query
    let query = useQuery();
    let buscarA = query.get("_sr");
    //console.log("BUSCAR", buscarA, buscar);

    return (
        <>
          Início
        </>
    )
}
export default InicioProdutos;